module.exports = __webpack_public_path__ + "img/resourceOrange.85a77dfe.png";